import { Component, OnInit, TemplateRef } from '@angular/core';
import { AppComponentName, Message, MessageActionType, MessageType, Sensor, SensorGroup, SensorGroupHistory, SensorGroupHistoryInfo, SensorGroupInfo, UserGroup, Event, LastSensorReading, SensorReadingType, TimeZoneDisplay } from '@models';
import { ChartFavoriteRequest } from '@models/ChartFavorite/chartFavoriteRequest.model';
import { ChartFavoriteInfo } from '@models/ChartFavorite/chartfavoriteInfo.model';
import { DateRanges } from '@models/ranges';
import { AppMessageService } from '@services/message.service';
import { SensorService } from '@services/sensor.service';
import { SensorGroupService } from '@services/sensorgroup.service';
import { UserService } from '@services/user.service';
import { AppComponent } from 'app/app.component';
import { ChangeLogNotesComponent, ChangeLogNotesParams } from 'app/components/messages/changelog-notes/changelognotes.components';
import { SensorReadingsService } from 'app/components/sensor-readings/sensor-readings.service';
import { SensorDataModalComponent, SensorDataModalParams } from 'app/components/sensors/sensor-data-modal/sensor-data-modal.component';
import { Authorization } from 'app/shared/classes/authorization';
import { CommonShared } from 'app/shared/classes/common';
import moment from 'moment';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

interface DateRange {
  startDate: moment.Moment;
  endDate: moment.Moment;
}

export interface CreateUpdateSensorgroupParams {
  sensorGroups: SensorGroup[];
  sensorGroup: SensorGroup;
  sensorGroupHistory: SensorGroupHistory[];
  userGroups: UserGroup[];
  associatedUserGroups: UserGroup[];
  modalMode: string;
  allSensors: Sensor[];
  events: Event[];
  btMacAddressPrefixes: {};
 }

@Component({
  standalone: false,
  selector: 'create-update-sensorgroup',
  templateUrl: './create-update-sensorgroup.component.html',
  styleUrls: ['./create-update-sensorgroup.component.scss']
})

export class CreateUpdateSensorgroupComponent implements OnInit, CreateUpdateSensorgroupParams {

  common = new CommonShared();
  auth = new Authorization();

  modalDragOn: boolean = false;

  sensorGroup: SensorGroup;
  sensorGroups: SensorGroup[];
  sensorGroupHistory: SensorGroupHistory[] = [];
  userGroups: UserGroup[] = [];
  associatedUserGroups: UserGroup[] = [];
  modalMode: string;
  allSensors: Sensor[] = [];
  events: Event[] = [];
  btMacAddressPrefixes: {};

  username: string;
  duplicateName = false;
  sensorsDisplayed: Sensor[] = [];
  modalRef: BsModalRef;
  logModalRef: BsModalRef;
  globalSwitch = false;
  changeLogNotes = '';
  preEditObjectAsJSONString = '';
  selectedUserGroup: UserGroup;
  allSensorUUIDsDisplayed = false;

  createFavoriteChecked: boolean = false;
  selectedSensorDataTypes: SensorReadingType[] = [];
  sensorDataTypes: SensorReadingType[] = [];
  chartFavorites: ChartFavoriteInfo[] = [];
  associatedChartFavorites: ChartFavoriteInfo[] = [];
  newChartFavoriteName: string;

  scanModalRef: BsModalRef;
  scannedSensor = '';
  visitedScan = false;
  sensorToAdd: Sensor;

  invalidDates: moment.Moment[] = [];
  selectedDateRange: DateRange = { startDate: moment().startOf('day').subtract(1, 'days'), endDate: moment().endOf('day') };
  isInvalidDate = (m: moment.Moment) => this.invalidDates.some(d => d.isSame(m, 'day'));
  
  availableDevices: MediaDeviceInfo[];
  selectedDevice: MediaDeviceInfo;

  selectedTimeZone: TimeZoneDisplay = TimeZoneDisplay.Local;
  selectedTimeZoneOffset: number = moment().utcOffset();

  ranges = DateRanges;

  sensorGroupHistoryCols = [
    { field: 'name', header: 'Name/Description', width: '24%' },
    { field: 'startDate', header: 'Start/End Dates', width: '16%' },
    { field: 'sensorName', header: 'Sensor Name', width: '24%' },
    { field: 'uuid', header: 'UID', width: '32%' },
    { field: 'chart', header: '', width: '4%' }
  ];

  sensorGroupUUIDCols = [
    { field: 'checkbox', header: '', width: '6%' },
    { field: 'name', header: 'Name', width: '19%' },
    { field: 'uuid', header: 'UID', width: '33%' },
    { field: 'type', header: 'Type', width: '12%' },
    { field: 'lastReading.date', header: 'Last Reading', width: '21%' },
    { field: 'ignore', header: 'Ignore', width: '8%' }
  ];

  sensorGroupEventCols = [
    { field: 'name', header: 'Event Name', width: '80%' },
    { field: 'isDisabled', header: 'Enabled', width: '20%' }
  ];
  
  public datatypeDropDownSettings: any = {
    singleSelection: false,
    idField: 'id',
    textField: 'type',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: false
  };

  public crops: string[] = [ '-', 'Alfalfa', 'Arabidopsis', 'Bush Bean', 'Canola',
    'Corn', 'Cotton', 'Cowpea', 'Green Foxtail', 'Millet',
    'Potato', 'Rice', 'Sorghum', 'Soybean', 'Sugarcane',
    'Sunflowers', 'Tobacco', 'Wheat' ];

  public sensorIgnoreDDOptions: string[] = [ 'select', '1 hr', '4 hrs', '8 hrs', 'day', 'week', 'month', '6 months', 'year', 'always' ];

  public cropListconfig: any = {
    displayKey: '',
    search: true,
    height: '300px',
    placeholder: 'Select crop type',
    noResultsFound: 'No crop found!',
    searchOnKey: ''
  };

  public userGroupconfig: any = {
    displayKey: 'name',
    search: true,
    height: '300px',
    placeholder: 'Select User Group',
    noResultsFound: 'No User Groups found!',
    searchOnKey: 'name'
  };

  sensorSearch: string;
  searchedRecentNames: boolean;
  searchSensorUUID: string;
  sensorGroupTitle: string;

  


  constructor(public bsModalRef: BsModalRef, private toastr: ToastrService, private modalService: BsModalService, private global: AppComponent,
              public _sensorService: SensorService, public _userService: UserService, public _appMessageService: AppMessageService,
              public _sensorGroupService: SensorGroupService, public _sensorReadingService: SensorReadingsService) {
    this.globalSwitch = global.globalSwitch;
  }


  ngOnInit() {
    this._userService.getCurrentUserEmailUsingAzureAD().subscribe(
      results => {
        this.username = results['value'];
        if (this.username != null && this.username !== '') {
          this.startUp();
        }
      },
      err => {
        this.toastr.error('Error unable to read current user\'s info');
      });
  }


  startUp() {
    if (this.modalMode.toLowerCase() == "create") {
      this.createSensorGroup();
    }
    else {
      this.editSensorGroup(this.sensorGroup);
    }
  }


  setDragOn(drag: boolean) {
    this.modalDragOn = drag;

    if (drag) {
      setTimeout(() => {
        this.modalDragOn = false;
      },3000);
    }
  }


  createSensorGroup() {
    this.sensorSearch = '';
    this.changeLogNotes = '';
    this.createFavoriteChecked = false;
    this.allSensors.forEach(s => s.checked = false);
    this.sensorGroupTitle = 'New Sensor Group';

    this.sensorGroup = {} as SensorGroup;
    this.sensorGroup.createdDate = moment().local().toDate(),
    this.sensorGroup.modifiedDate = this.sensorGroup.createdDate,
    this.sensorGroup.id = 0;
    this.sensorGroup.crop = '-';
    this.sensorGroup.beginDate = moment().local().toDate();
    this.sensorGroup.endDate = moment().local().add(10, 'years').toDate();
    this.selectedDateRange = { startDate: moment(this.sensorGroup.beginDate), endDate: moment(this.sensorGroup.endDate) };
    this.sensorGroup.isDisabled = false;
    this.sensorGroup.sensors = [];
    this.sensorsDisplayed = [];
    this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    this.sensorGroup.userName = this.username;
    
    this.sensorGroupHistory = [];

    this.auth.mapUserAccessForSensorGroup(this.sensorGroup, this.globalSwitch, this.username, this.userGroups);
  }


  editSensorGroup(sensorGroup: SensorGroup) {
    this.sensorSearch = '';
    this.changeLogNotes = '';
    this.createFavoriteChecked = false;

    if (sensorGroup.userGroupId == null || sensorGroup.userGroupId < 1) {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == -1);
    } else {
      this.selectedUserGroup = this.associatedUserGroups.find(u => u.id == sensorGroup.userGroupId);
    }

    this.sensorGroup = this.common.cloneSensorGroup(sensorGroup);
    if (this.sensorGroup.beginDate == undefined || this.sensorGroup.endDate == undefined) {
      this.selectedDateRange = undefined;
    }
    else {
      this.selectedDateRange = { startDate: moment(this.sensorGroup.beginDate), endDate: moment(this.sensorGroup.endDate) };
    }
    
    this.syncAllSensorSelectionWithSensorGroup(this.sensorGroup);
    
    this.searchSensorGroupHistoryById(this.sensorGroup.id);

    this.buildSensorUUIDDisplayList(false);

    this.preEditObjectAsJSONString = JSON.stringify(this.sensorGroup);
    this.sensorGroupTitle = sensorGroup.name;

    this.getDataTypesForSensors(this.sensorGroup.sensors.map(s => s.id));
  }


  updateSensorGroup(template: TemplateRef<any>) {
    if (this.duplicateNamecheck(this.sensorGroup.name)) {
      return;
    }

    if (this.sensorGroup.name == '') {
      this.toastr.error('Please include a group name');
      return;
    }

    var invalidDates = false;
    this.sensorGroupHistory.forEach(x => { if (x.changed && this.validateSensorGroupHistoryChanges(x) == false) invalidDates = true; });
    if (invalidDates) {
      this.toastr.error('Please fix date changes in the History tab. Aborting save');
      return;
    }

    this.bsModalRef.hide();
    //this.sensorGroup.sensors = this.sensorsDisplayed.filter(s => s.checked == true);
    this.sensorGroup.sensors = this.allSensors.filter(s => s.checked == true);
    this.sensorGroup.sensors.forEach(x => {
      var sensorDisplayed = this.sensorsDisplayed.find(y => y.id == x.id);
      if (sensorDisplayed != undefined) {
        x.ignore = sensorDisplayed.ignore;
        x.ignoreDuration = sensorDisplayed.ignoreDuration;
        x.ignoreUntil = sensorDisplayed.ignoreUntil;
      }
    });

    this.common.updateUserInfoForSensorGroup(this.sensorGroup, this.selectedUserGroup, this.username);

    this.auth.mapUserAccessForSensorGroup(this.sensorGroup, this.globalSwitch, this.username, this.userGroups);
    const sensorGroupInfo = this.common.mapSensorGroup2SensorGroupInfo(this.sensorGroup);

    if (this.createFavoriteChecked) {
      this.getChartFavorites(template);
    }

    if (this.sensorGroup.id < 1) {
      sensorGroupInfo.endDate = undefined;
      this.onCreate(this.sensorGroup, sensorGroupInfo);
    }
    else {
      this.sensorGroupHistory.forEach(x => {
        if (x.changed) {
          this.createOrUpdateSensorGroupHistory(x);
        }
      });
      
      sensorGroupInfo.beginDate = sensorGroupInfo.modifiedDate,
      sensorGroupInfo.endDate = moment.utc().toDate(),
      this.onEdit(this.sensorGroup, sensorGroupInfo);
    }
  }


  onEdit(sensorGroup: SensorGroup, sensorGroupInfo: SensorGroupInfo) {
    this._sensorGroupService.updateSensorGroup(sensorGroupInfo, this.username).subscribe(
      results => {
        if (results != null) {
          this.createMessageData(MessageActionType.Edited, sensorGroup, this.common.getEditChanges4SensorGroups(sensorGroup, this.preEditObjectAsJSONString));
          this.toastr.success('Sensor Group Updated');
        } else {
          this.toastr.warning('Error saving edits. Reload page.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while updating sensor groups. Reload page.');
      });
  }


  onCreate(sensorGroup: SensorGroup, sensorGroupInfo: SensorGroupInfo) {
    this._sensorGroupService.createSensorGroup(sensorGroupInfo).subscribe(
      results => {
        if (results != null) {
          this.createMessageData(MessageActionType.New, sensorGroup, '');
          this.toastr.success('Success');
        } else {
          this.toastr.warning('Error with creating new sensor group. Reload page.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while adding sensor group. Reload page.');
      });
  }

  
  duplicateNamecheck(name: string): boolean {
    this.duplicateName = false;
    this.sensorGroups.forEach(s => {
      if (s.name.toUpperCase() == name.toUpperCase() && s.id != this.sensorGroup.id){
        this.toastr.error('Sensor Group name is already in use');
        this.duplicateName = true;
        return this.duplicateName;
      }
    });
    return this.duplicateName;
  }

  
  sensorGroupHistoryDatesChanged(sensorGroupHistory: SensorGroupHistory) {
    sensorGroupHistory.changed = true;
  }


  validateDate(dateString: string): boolean {
    if (dateString == undefined || dateString == '') {
      return false;
    }

    var dateVar = moment(dateString).toDate();

    if (!(dateVar instanceof Date) || isNaN(dateVar.getMinutes())) {
      return false;
    }
  }


  validateSensorGroupHistoryChanges(sensorGroupHistory: SensorGroupHistory): boolean {
    if (this.validateDate(sensorGroupHistory.startDate) == false) {
      this.toastr.error('Start Date is invalid');
      return false;
    }
    if (this.validateDate(sensorGroupHistory.endDate) == false) {
      this.toastr.error('End Date is invalid');
      return false;
    }

    var startDate = moment(sensorGroupHistory.startDate);
    var endDate = moment(sensorGroupHistory.endDate);

    if (startDate.isSameOrAfter(endDate)) {
      this.toastr.error('Dates are invalid. Start date is same or later than end date');
      return false;
    }

    return true;
  }


  createOrUpdateSensorGroupHistory(sensorGroupHistory: SensorGroupHistory): boolean {
    if (!this.validateSensorGroupHistoryChanges(sensorGroupHistory)) {
      return false;
    }

    var sensorGroupHistoryInfo: SensorGroupHistoryInfo = {
      id: sensorGroupHistory.id,
      parentId: sensorGroupHistory.parentId,
      name: sensorGroupHistory.name,
      description: sensorGroupHistory.description,
      startDate: moment(sensorGroupHistory.startDate).local().toDate(),
      endDate: moment(sensorGroupHistory.endDate).local().toDate(),
      sensorUUIDs: sensorGroupHistory.sensorUUIDs,
      crop: sensorGroupHistory.crop,
      plantDate: sensorGroupHistory.plantDate,
      sensors: sensorGroupHistory.sensors
    };

    this._sensorGroupService.createOrUpdateSensorGroupHistory(sensorGroupHistoryInfo).subscribe(
      results => {
        if (results != null) {
          sensorGroupHistory.changed = false;
          if (sensorGroupHistoryInfo.id < 0) {
            this.searchSensorGroupHistoryById(sensorGroupHistoryInfo.parentId);
          }
          this.toastr.success("Updated sensor group history");
          return true;
        } else {
          this.toastr.warning('Unable to update sensor group history');
        }
        return false;
      },
      err => {
        this.toastr.error('Error occurred while updating sensor group history');
        return false;
      });
  }

  
  searchSensorGroupHistoryById(sensorGroupId: number): void {
    this._sensorGroupService.searchSensorGroupHistoryById(sensorGroupId).subscribe(
      results => {
        if (results != null) {
          this.sensorGroupHistory = results;
          this.sensorGroupHistory.forEach(g => {
            var currentGroup = this.sensorGroups.find(x => x.id == g.parentId);

            if (currentGroup == undefined) {
              g.parentName = "-no longer exists-";
            }
            else {
              g.parentId = currentGroup.id;
              g.parentName = currentGroup.name;
            }

            g.startDate = moment.utc(g.startDate).local().format("YYYY-MM-DDTHH:mm");
            g.endDate = moment.utc(g.endDate).local().format("YYYY-MM-DDTHH:mm");

            if (g.id < 1) {
              g.endDate = undefined;
              g.name = g.parentName;
            }

            g.associatedEvents = (currentGroup != undefined && currentGroup.events != undefined) ? currentGroup.events.map(x => x.name) : []
          });

          this.searchedRecentNames = true;
          this.sensorGroupHistory = this.sensorGroupHistory.sort((x, y) => (x.startDate >= y.startDate) ? -1 : 1);

        } else {
          this.toastr.warning('No history found for sensor group(s)');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor group history');
      });
  }


  createMessageData(msgActionType: MessageActionType, sensorGroup: SensorGroup, msgNote: string) {
    const message: Message = {
      id: 0,
      messageType: MessageType.Audit,
      appComponentName: AppComponentName.SensorGroups,
      actionType: msgActionType,
      appComponentItem: (sensorGroup != undefined) ? sensorGroup.name : '',
      details: msgNote,
      userNotes: this.changeLogNotes,
      count: 1,
      acknowledged: false,
      userName: this.username,
      userGroupId: (sensorGroup != undefined) ? sensorGroup.userGroupId : null,
    };

    this._appMessageService.createAppMessage(message).subscribe(
      results => {
        if (results != null) {
          //this.toastr.success('Success');
        } else {
          //this.toastr.warning('Not found.');
        }
        return;
      },
      err => {
        //this.toastr.error('Error occurred while saving change log.');
      });
  }


  public addSensor(): void {
    if (this.scannedSensor == undefined || this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }
    this.scannedSensor = this.createUUID(this.scannedSensor);
    this.allSensors.forEach(sensor => {
      if (sensor['uuid'].toLowerCase() === this.scannedSensor.toLowerCase()) {
        const sensorIndex = this.allSensors.indexOf(sensor);
        sensor['checked'] = true;
        this.sensorToAdd = sensor;
        this.scannedSensor = '';
        this.allSensors.splice(sensorIndex, 1);
        this.allSensors.unshift(this.sensorToAdd);
        this.toastr.success('Sensor found in database and adding to list');
        if (!this.allSensorUUIDsDisplayed) {
          this.buildSensorUUIDDisplayList(false);
        }
        return;
      }
    });
    if (!(this.scannedSensor == '')) {
      this.sensorToAdd = {
        id: 0,
        uuid: this.scannedSensor.toLowerCase(),
        sensorReadingTypes: undefined,
        sensorReadingTypeNames: '',
        checked: true,
        modifiedDate: new Date(),
        userName: this.username,
        userGroupId: undefined,
        virtualSensor: undefined,
        lastReading: this.common.createNewLastReading(0),
        sensorCalibrationHistory: null,
      };
      this.allSensors.unshift(this.sensorToAdd);
      this.toastr.success('Successfully added new sensor');
      if (!this.allSensorUUIDsDisplayed) {
        this.buildSensorUUIDDisplayList(false);
      }
      this.scannedSensor = '';
    }
  }


  public createUUID(uuid): string {
    uuid = uuid.split(':').join('');
    const formattedUUID = [];
    const maxLength = 36;
    let uuidLengthTracker = uuid.length - 1;
    for (let i = 0; i <= maxLength - 1; i++) {
      if (i == 12 || i == 17 || i == 22 || i == 27) {
        formattedUUID.unshift('-');
      } else if (uuidLengthTracker >= 0) {
        formattedUUID.unshift(uuid.charAt(uuidLengthTracker));
        uuidLengthTracker--;
      } else {
        formattedUUID.unshift('0');
      }
    }
    return formattedUUID.join('');
  }


  openScanModal(template: TemplateRef<any>): void {
    this.scanModalRef = this.modalService.show(template);
    this.scannedSensor = '';
  }

  
  public scannedSensorQR(): void {
    if (this.scannedSensor == undefined || this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
      return;
    }

    this.searchSensorUUID = this.scannedSensor;
    this.scanModalRef.hide();
  }


  ignoreSensor(): void {
    if (this.scannedSensor == '') {
      this.toastr.warning('Please scan a sensor');
    } else {
      this.toastr.warning('Ignored ' + this.scannedSensor);
      this.scannedSensor = '';
    }
  }

  public scanComplete(event: string): void {
    this.visitedScan = false;
    if (this.scannedSensor == '') {
      const splitEvent = this.createUUID(event);
      this.allSensors.forEach(sensor => {
        if (sensor['uuid'].toLowerCase() === splitEvent.toLowerCase() && sensor['checked'] == true) {
          this.toastr.error('This sensor is already selected');
          this.visitedScan = true;
          return;
        }
      });
      if (!this.visitedScan) {
        this.toastr.success('Scanned ' + event);
        this.scannedSensor = event;
        this.visitedScan = false;
      }
    } else {
      this.toastr.warning('Please choose to add or ignore current sensor');
    }

  }


  syncAllSensorSelectionWithSensorGroup(sensorGroup: SensorGroup) {
    this.allSensors.forEach(a => {
      a.checked = false;
      a.ignore = false;
      a.ignoreUntil = undefined;
    });

    if (sensorGroup.sensors != undefined && sensorGroup.sensors.length > 0) {
      sensorGroup.sensors.forEach(s => {
        var matchedSensor = this.allSensors.find(x => x.id == s.id);
        
        if (matchedSensor != undefined) {
          matchedSensor.checked = true;
          matchedSensor.ignore = s.ignore;
          matchedSensor.ignoreUntil = s.ignoreUntil
        }
      });
    }
  }


  getDataTypesForSensors(sensorIds: number[]): void {
    this._sensorService.getReadingTypesForSensors(sensorIds, '').subscribe(
      results => {
        if (results != null) {
          this.sensorDataTypes = results;
          this.common.sortArrayByTypeParm(this.sensorDataTypes);

          this.selectedSensorDataTypes = this.selectedSensorDataTypes.filter(x => this.sensorDataTypes.map(y => y.type).includes(x.type));
        } else {
          this.toastr.warning('No data types found for given sensors found');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving sensor data types');
      });
  }


  getLastSensorReadingDatesForSensors(sensors: Sensor[]) {
    var unloadedSensorList = sensors.filter(x => !x.lastReading.isLoaded && !x.lastReading.waitingForLoad);

    if (unloadedSensorList.length < 1) {
      return;
    }

    var sensorIds = unloadedSensorList.map(y => y.id);

    unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = true);

    this._sensorService.getLastSensorReadings(sensorIds).subscribe(results => {

      if (results != null) {
        var lastReadings: LastSensorReading[] = results;

        lastReadings.forEach(x => {
          var sensor = unloadedSensorList.find(y => y.id == x.sensorId);

          if (sensor != undefined) {
            sensor.lastReading.date = moment.utc(x.date).toDate();
            sensor.lastReading.isLoaded = true;
            sensor.lastReading.waitingForLoad = false;
            sensor.lastReading.displayColor = this.common.getColorCodeForLastReadingDate(sensor.lastReading.date);
          }
        });
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
      }
      else {
        unloadedSensorList.forEach(x => x.lastReading.waitingForLoad = false);
        this.toastr.warning('Failed to retrieve last sensor readings info');
      }
    });
  }


  sensorSelectionChanged(sensor: Sensor) {
    var selectedSensor = this.allSensors.find(x => x.id == sensor.id);
    selectedSensor.checked = sensor.checked;
    this.getDataTypesForSensors(this.sensorsDisplayed.filter(s => s.checked).map(s => s.id));
  }





  buildSensorUUIDDisplayList(showAll: boolean) {
    this.allSensorUUIDsDisplayed = showAll;

    if (!showAll) {
      this.sensorsDisplayed = this.allSensors.filter(s => s.checked == true);
    } else {
      this.sensorsDisplayed = this.allSensors;
    }

    this.sensorsDisplayed = JSON.parse( JSON.stringify(this.sensorsDisplayed) );
    this.updateSensorNameAndType(this.sensorsDisplayed);

    this.getLastSensorReadingDatesForSensors(this.sensorsDisplayed);
    //this.sensorsDisplayed.forEach(x => this.getLastSensorReadingDatesForSensors([x]));

    this.sensorsDisplayed.sort((x, y) => {
      return (x.checked == y.checked) ? 0 : x.checked ? -1 : 1;
    });
  }


  updateSensorNameAndType(sensors: Sensor[]) {
    sensors.forEach(s => {
      if (s.name == undefined || s.name == '') {
        s.name = this.common.extractNameFromUUID(s.uuid, this.btMacAddressPrefixes);
        s.inlineEdited = true;
      }
      if (s.type == undefined || s.type == '') {
        s.type = this.common.extractTypeFromUUID(s.uuid, this.btMacAddressPrefixes);
        s.inlineEdited = true;
      }
    });
  }


  getCheckedSensorUUIDs(): number {
    return this.allSensors.filter(x => x.checked).length;
  }


  extractMacAddressFromUUID(uuid: string): string {
    let macAddress = '';
    if (uuid.length >= 12) {
      macAddress = uuid.substr(uuid.length - 12).toUpperCase();

      return  macAddress.slice(0, 2) + ':' +
              macAddress.slice(2, 4) + ':' +
              macAddress.slice(4, 6) + ':' +
              macAddress.slice(6, 8) + ':' +
              macAddress.slice(8, 10) + ':' +
              macAddress.slice(10, 12);
    }
    return '';
  }


  searchSensorsTextChanged() {
    const searchLimit = 500;
    let checkedCount = 0;

    if (this.sensorSearch == '' || this.sensorSearch == '*') {
      this.sensorsDisplayed = this.allSensors.filter(s => s.checked == true);
      checkedCount = this.sensorsDisplayed.length;
    }
    else {
      this.sensorSearch = this.sensorSearch.toLowerCase();

      const searchResults = this.allSensors.filter(s => (s.uuid != undefined ? s.uuid.toLowerCase().includes(this.sensorSearch) : false) ||
                                                      (s.name != undefined ? s.name.toLowerCase().includes(this.sensorSearch) : false) ||
                                                      (s.type != undefined ? s.type.toLowerCase().includes(this.sensorSearch) : false)); // || s.checked == true);

      const displayCount = (searchResults.length > checkedCount + searchLimit) ? checkedCount + searchLimit : searchResults.length;

      this.sensorsDisplayed = searchResults.slice(0, displayCount);                             // Then only take the allow search limit
    }

    this.getLastSensorReadingDatesForSensors(this.sensorsDisplayed);
  }


  clearSearchFilter() {
    this.sensorsDisplayed = this.allSensors.filter(s => s.checked == true);
  }


  createOrUpdateChartFavorite(favorite: ChartFavoriteInfo) {
    if (favorite == undefined) {
      var exitingNameIndex = this.chartFavorites.findIndex(x => x.name.toLowerCase() == this.newChartFavoriteName.toLowerCase());

      if (exitingNameIndex > -1) {
        this.toastr.error('Please provide unique chart favorite name.');
        return;
      }

      if (this.newChartFavoriteName == undefined || this.newChartFavoriteName == '') {
        this.toastr.error('Please provide a chart favorite name or select an existing chart to replace.');
        return;
      }
    }

    this.modalRef.hide();

    var chartFavoriteRequest: ChartFavoriteRequest = {
      id: (favorite != undefined) ? favorite.id : 0,
      name: (favorite != undefined) ? favorite.name : this.newChartFavoriteName,
      sensorGroupID: this.sensorGroup.id,
      sensorGroupIDs: [this.sensorGroup.id],
      sensorIDs: this.sensorGroup.sensors.map(s => s.id),
      sensorReadingTypeIDs: this.selectedSensorDataTypes.map(x => x.id),
      dateRange: 'Last 7 Days',
      isManualScaling: false,
      scaleYMin: undefined,
      scaleYMax: undefined,
      outlierYMin: undefined,
      outlierYMax: undefined,
      chartDetails: undefined,
      userName: this.sensorGroup.userName,
      userGroupId: this.sensorGroup.userGroupId
    }

    if (favorite == undefined) {
      this._sensorReadingService.createChartFavorite(chartFavoriteRequest).subscribe(
        result => {
          if (result === 'success') {
            //this.createMessageData(MessageActionType.New, chartFavoriteRequest, '');
            this.toastr.success('Chart favorite created successfully.');
          } else {
            this.toastr.warning('Unable to create/update chart favorite');
          }
        },
        err => {
          this.toastr.error('Error occurred while saving chart favorite');
        }
      );
    }
    else {
      this._sensorReadingService.updateChartFavorite(chartFavoriteRequest, this.username).subscribe(
        result => {
          if (result === 'success') {
            //this.createMessageData(MessageActionType.New, chartFavoriteRequest, '');
            this.toastr.success('Chart favorite updated successfully.');
          } else {
            this.toastr.warning('Unable to create/update chart favorite');
          }
        },
        err => {
          this.toastr.error('Error occurred while saving chart favorite');
        }
      );
    }

  }


  getChartFavorites(template: TemplateRef<any>): void {
    this._sensorReadingService.getChartFavorites().subscribe(
      results => {
        if (results != null) {
          this.chartFavorites = results;
          this.chartFavorites.forEach(c => { if (c.sensorGroup) { c.sensorGroup.sensors = c.sensors; } });
          this.reviewChartFavoriteStatus(template);
        }
        else {
          this.toastr.warning('No chart favorites found.');
        }
        return;
      },
      err => {
        this.toastr.error('Error occurred while retrieving list of existing chart favorites.');
      });
  }


  reviewChartFavoriteStatus(template: TemplateRef<any>) {
    this.newChartFavoriteName = this.sensorGroup.name + " -- 7Day auto";
    var count = 2;
    while (this.chartFavorites.findIndex(x => x.name.toLowerCase() == this.newChartFavoriteName.toLowerCase()) > -1) {
      this.newChartFavoriteName = this.sensorGroup.name + " -- 7Day auto - " + count.toString();
      count++;
    }

    this.associatedChartFavorites = this.chartFavorites.filter(x => {
      if (x.sensorGroup?.id === this.sensorGroup.id) {
        if (x.sensorGroup?.id != undefined && x.userGroupId === this.sensorGroup.userGroupId) {
          return true;
        }
        else if (x.userName.toLowerCase() === this.sensorGroup.userName.toLowerCase()) {
          return true;
        }
        else {
          return false;
        }
      }
    });

    this.modalRef = this.modalService.show(template, { animated: false, backdrop: false, ignoreBackdropClick: true } );
  }


  plantDateChanged() {
    //console.log(this.sensorGroup.plantDate);
  }


  addAssociatedVirtualSensors() {
    var virtualSensorPrefix = "sensorgroup-" + this.sensorGroup.id;

    const searchResults = this.allSensors.filter(s => s.uuid != undefined && s.uuid.toLowerCase().startsWith(virtualSensorPrefix));

    searchResults.forEach(s => {
      var index = this.sensorsDisplayed.findIndex(x => x.id == s.id);
      if (index < 0) {
        this.sensorsDisplayed.push(s);
      }
    });

    this.sensorsDisplayed.sort((a, b) => {
      if (a.uuid.startsWith(virtualSensorPrefix)) {
        return -1;
      }
      if (a.checked == b.checked) {
        return 0;
      }

      if (a.checked) {
        return 1;
      }
      else {
        return -1;
      }
    });
  }


  addNotes2ChangeLog() {
    this.changeLogNotes = '';

    const params: ChangeLogNotesParams = {
      changeLogNotes: this.changeLogNotes,
      userGroupId: 0,
      category: ''
    };

    var modalRef = this.modalService.show(ChangeLogNotesComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, class: 'modal-above-confirmdialog', initialState: params });
    modalRef.content.onChangeLogNotes.subscribe((value) => {
      this.changeLogNotes = value;
    });
  }


  public camerasFound(cameras: MediaDeviceInfo[]) {
    this.availableDevices = cameras;
    if (this.availableDevices.length > 0) {
      this.onDeviceSelectChange(this.availableDevices[this.availableDevices.length-1].deviceId);
    }
  }


  onDeviceSelectChange(selectedValue: string) {
    this.selectedDevice = this.availableDevices.find(x => x.deviceId == selectedValue);
  }


  sensorIgnoreStateChanged(sensor: Sensor) {
    if (sensor.ignore) {
      sensor.ignoreShowOptions = true;
      sensor.ignoreDuration = this.sensorIgnoreDDOptions[0];
    }
  }


  sensorIgnoreDurationChanged(sensor: Sensor) {
    sensor.ignoreShowOptions = false;
    var hours = this.getIgnoreDurationInHours(sensor.ignoreDuration);
    sensor.ignoreUntil = moment.utc().add(hours, 'hours').toDate();
  }


  getIgnoreDurationInHours(durationString: string): number {
    switch (durationString) {
      case '1 hr':
        return 1;

      case '4 hrs':
        return 4;

      case '8 hrs':
        return 8;

      case 'day':
        return 24;

      case 'week':
        return 24*7;

      case 'month':
        return 24*30.5;

      case '6 months':
        return 24*182;

      case 'year':
        return 24*365;

        case 'always':
          return 24*365*20;

      default:
        return 24;

    }
  }


  showSensorDataPreview(sensor: Sensor, startDate: Date): void {
    this.loadSavedSettings();

    const params: SensorDataModalParams = {
      sensor: sensor,
      selectedTimeZone: this.selectedTimeZone,
      selectedTimeZoneOffset: this.selectedTimeZoneOffset,
      selectedDateRange: { startDate: moment(startDate).startOf('day'), endDate: moment(startDate).endOf('day').add(7, 'days') },
      selectedDefaultReadingType: ''
    };

    this.modalService.show(SensorDataModalComponent, { animated: false, backdrop: false, ignoreBackdropClick: true, initialState: params });
  }

  
  loadSavedSettings() {
    [this.selectedTimeZone, this.selectedTimeZoneOffset] = this.common.setTimeZoneSelection(localStorage.getItem('TimeZoneSelected'));
  }


}
